import { Navigate, useParams } from 'react-router-dom';
import { tenantBasePath } from '../lib/tenant.js';

export function TenantRootRedirect() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return null;
  return <Navigate to={`${tenantBasePath(slug)}/admin`} replace />;
}
